export const isPlanLimitError = (message: string) => message.toLowerCase().includes("plan:")
